module.exports = __webpack_public_path__ + "static/media/pontevedra.5785c419.jpg";